import { AppContext } from "../../context/context";
import { decryptData, isTokenValid } from '../../utils/utils';
import { Dispatch, useContext, useEffect, useState } from "react";
import { ls } from "../../localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import SmartSheetPlay from "./SmartSheetPlay";
import { useSelector } from "react-redux";
import { IReducer, IUserReducer, ISmartSheetData } from "../../interface/interface";
import { useDispatch } from "react-redux";
import { userAction, smartSheetActions } from "../../reduxStore";
import { Player } from "@lottiefiles/react-lottie-player";

interface ISmartSheetQuery {
    currentUser: any,
    loId: string,
    smartSheetData: ISmartSheetData,
    token: string
}

export function SmartSheet(props: any) {
    const navigate = useNavigate();
    const dispatch: Dispatch<any> = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const QUERY: ISmartSheetQuery | any = queryParams.get("query");
    const state: any = useContext(AppContext);
    const [isLoader, setIsLoader] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const userReducer: IUserReducer = useSelector((state: IReducer) => state.userReducer);

    useEffect(() => {
        verifyAndSetData();
    }, [])

    const verifyAndSetData = async () => {
        try {
            setIsLoader(true);
            let query: ISmartSheetQuery = decryptData(QUERY);
            let currentUser = query.currentUser;

            console.log("Decrypted Query for SmartSheet: ", query);
            console.log("Current User from Query: ", currentUser);

            if (await isTokenValid(query.token) &&
                await ls.isValid(query.currentUser) &&
                await ls.isValid(query.smartSheetData)) {

                if (userReducer.currentUser.id && currentUser.id.toString() !== userReducer.currentUser.id.toString())
                    dispatch(userAction.setInitialState());

                dispatch(userAction.setCurrentUser(currentUser));
                dispatch(smartSheetActions.setSmartSheetInfo({
                    loId: query.loId,
                    smartSheetData: query.smartSheetData
                }));

                ls.setToken(query.token);
                ls.setDBToken(currentUser.dbToken);
                setIsDataLoaded(true);
            }
            else {
                console.log("No query found for SmartSheet");
                state.messageForParent('close');
                navigate('/pageNotFound');
            }
            setIsLoader(false);
        } catch (error) {
            console.log(error);
            state.messageForParent('close');
            navigate('/pageNotFound');
        }
    }

    return (<>
        {(isLoader) && (
            <div className='preloader d-flex align-items-center justify-content-center'>
                <Player id={"loaderAnimation"} autoplay loop style={{ "width": "40%", "height": "30%" }} speed={1} src={"./assets/animation/themes/space/loader.json"}></Player>
            </div>
        )}
        {(!isLoader && isDataLoaded) && (
            <SmartSheetPlay {...props} />
        )}
    </>)
}
export default SmartSheet;
